import * as stylex from "@stylexjs/stylex";
import { TOCContext } from "components/hero-vis/TOC";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { breakpoints, colors, layoutAreas } from "../consts.stylex";
import { themeVars } from "../theme.stylex";
import { typography } from "../typography.stylex";
import { linkBody } from "./links";
const styles = {
    blockquote: {
        "--mdx-blockquote-first-letter-color": "x4iker1",
        $$css: true
    },
    table: {
        kMwMTN: "xjvpvmj",
        kLvRdT: "x1mwwwfo",
        kzqmXN: "xh8yej3",
        $$css: true
    }
};
// Merges an element's own incoming `className`/`style` (from the MDX renderer, e.g.
// rehype-slug adding heading ids never touches these, but plugins can) with this
// component's StyleX output and, optionally, a marker class used by a global-CSS escape
// hatch for content this component doesn't render itself (see style.global.css).
function mergeProps({ className, style, ...rest }, stylexProps, markerClass) {
    return {
        ...rest,
        className: [
            markerClass,
            stylexProps?.className,
            className
        ].filter(Boolean).join(" "),
        // Spreading `undefined` is a safe no-op, so this doesn't need a truthiness check —
        // avoids relying on `||`/`?:` precedence, which is easy to misread here.
        style: {
            ...stylexProps?.style,
            ...style
        }
    };
}
export const baseElements = {
    h1: (props)=><h1 {...mergeProps(props, stylex.props(typography.heading1))}/>,
    h2: (props)=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { addId, removeId } = React.useContext(TOCContext);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [ref, inView] = useInView({
            rootMargin: "30% 0px 10% 0px"
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(()=>{
            if (props.id) {
                inView ? addId(props.id) : removeId(props.id);
            }
        }, [
            inView,
            addId,
            removeId,
            props.id
        ]);
        return <h2 ref={ref} {...mergeProps(props, stylex.props(typography.heading2), "mdx-h2")}>
        {props.children}
      </h2>;
    },
    h3: (props)=><h3 {...mergeProps(props, stylex.props(typography.heading3))}/>,
    p: (props)=><p {...mergeProps(props, stylex.props(typography.body2))}/>,
    a: (props)=><a {...mergeProps(props, stylex.props(linkBody.root))}/>,
    em: (props)=><strong {...mergeProps(props, {
            className: "x1j61x8r x117nqv4"
        })}/>,
    strong: (props)=><strong {...mergeProps(props, {
            className: "x1j61x8r x117nqv4"
        })}/>,
    blockquote: ({ children })=><div {...mergeProps({}, stylex.props(typography.body1, styles.blockquote), "mdx-blockquote")}>{children}</div>,
    hr: (props)=><hr {...mergeProps(props, {
            className: "xc342km xng3xce xjm9jq1 x15uhsjy xw7yly9 x1wsgfga"
        })}/>,
    img: (props)=><img {...mergeProps(props, {
            className: "x193iq5w"
        })}/>,
    ul: (props)=><ul {...mergeProps(props, undefined, "mdx-ul")}/>,
    ol: (props)=><ol {...mergeProps(props, undefined, "mdx-ol")}/>,
    table: ({ children })=><div className="xvaai34 x15z40wo xh8yej3 x14aock7 x1wghjex">
      <table {...mergeProps({}, stylex.props(typography.table, styles.table), "mdx-table")}>{children}</table>
    </div>
};
